import { ChangeDetectionStrategy, Component } from "@angular/core";
import {
  ExpandableAlertComponent,
  ExpandableAlertType,
} from "src/app/modules/shared/components/expandable-alerts/expandable-alert/expandable-alert.component";
import { AsyncPipe } from "@angular/common";
import { AlertModule } from "@storeblocks/alert-ng";
import { AccordionModule } from "@storeblocks/accordion-ng";

@Component({
  selector: "app-expandable-error-alert",
  templateUrl: "../expandable-alert/expandable-alert.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AsyncPipe, AlertModule, AccordionModule],
})
export class ExpandableErrorAlertComponent extends ExpandableAlertComponent {
  public type = ExpandableAlertType.Error;
}
